import { useTranslation } from 'react-i18next';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

import { useErrorContext } from 'contexts/ErrorsNavigationContext/ErrorsNavigationContext';
import { WebEDIError } from 'services/webediErrors/types';
import { Alert } from 'components/Display/Alert';
import { Badge, BadgeColor } from 'components/Display/Badge/Badge';
import { Button } from 'components/Form/Button/Button';

export const DiscrepanciesBanner = () => {
  const { t } = useTranslation();
  const { service } = useErrorContext<WebEDIError>();
  const numberOfErrors = service.useNumberOfActiveErrors();
  const focusOnCurrentError = service.focusOnCurrentError;

  if (numberOfErrors === 0) {
    return null;
  }

  return (
    <Alert withoutIcon severity="error" fullWidth>
      <div className="flex w-full items-center justify-between">
        <div>
          <p>{t('invoiceVerification:detailsPage.discrepanciesBanner.title')}</p>
        </div>
        <div className="flex gap-1">
          <Badge type="indicator" color={BadgeColor.red}>
            {t('invoiceVerification:detailsPage.discrepanciesBanner.badge', { count: numberOfErrors })}
          </Badge>
          {numberOfErrors > 1 ? (
            <>
              <Button
                variant="secondary-danger"
                size="extra-small"
                onClick={service.moveToPreviousError}
                iconOnly
                LeftIcon={ChevronUpIcon}
                analyticsId="invoiceVerification:previous_error"
              />
              <Button
                variant="secondary-danger"
                size="extra-small"
                onClick={service.moveToNextError}
                iconOnly
                LeftIcon={ChevronDownIcon}
                analyticsId="invoiceVerification:next_error"
              />
            </>
          ) : (
            <>
              <Button
                variant="secondary-danger"
                size="extra-small"
                onClick={focusOnCurrentError}
                analyticsId="invoiceVerification:errors_focus_first"
              >
                {t('invoiceVerification:detailsPage.discrepanciesBanner.focusOnError')}
              </Button>
            </>
          )}
        </div>
      </div>
    </Alert>
  );
};
